import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function IntroProducts() {
  const points = ['Amazon FBA', 'Amazon FBM', 'Amazon Wholesale', 'Bonos Premium', 'Entrenamiento para principiantes'];
  const scrollToProducts = () => {
    const el = document.getElementById('productos');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-green py-20 md:py-24 px-5 sm:px-6 relative overflow-hidden" data-id="element-348">
      <div className="absolute inset-0 overflow-hidden opacity-15 pointer-events-none" data-id="element-349">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-brand-gold rounded-full blur-3xl" data-id="element-350"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-351">
        <FadeIn data-id="element-352">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.15] tracking-tight mb-5" data-id="element-353">
            ¿Quieres generar ingresos vendiendo en Amazon pero no sabes por
            dónde empezar?
          </h2>
          <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-354">
            Aprende paso a paso los modelos que utilizan miles de vendedores
            para construir negocios online desde casa.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-355">
            {points.map((point, i) => <span key={i} className="inline-flex items-center gap-2 bg-white/5 border border-brand-gold/30 rounded-full px-4 py-2 text-sm font-medium text-white" data-id="element-356">
                <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-brand-gold/20 flex-shrink-0" data-id="element-357">
                  <Check className="w-2.5 h-2.5 text-brand-gold" strokeWidth={3.5} data-id="element-358" />
                </span>
                {point}
              </span>)}
          </div>

          <Button onClick={scrollToProducts} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-base md:text-lg font-bold px-12 py-5 shadow-2xl shadow-brand-gold/30" data-id="element-359">
            QUIERO EMPEZAR AHORA
          </Button>
        </FadeIn>
      </div>
    </section>;
}